"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeroImage = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constellation = require("@zillow/constellation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeroImage = function HeroImage(_ref) {
  var mobileImg = _ref.mobileImg,
      mobileImg2x = _ref.mobileImg2x,
      mobileWebp = _ref.mobileWebp,
      mobileWebp2x = _ref.mobileWebp2x,
      tabletPortraitImg = _ref.tabletPortraitImg,
      tabletPortraitImg2x = _ref.tabletPortraitImg2x,
      tabletPortraitWebp = _ref.tabletPortraitWebp,
      tabletPortraitWebp2x = _ref.tabletPortraitWebp2x,
      tabletLandscapeImg = _ref.tabletLandscapeImg,
      tabletLandscapeImg2x = _ref.tabletLandscapeImg2x,
      tabletLandscapeWebp = _ref.tabletLandscapeWebp,
      tabletLandscapeWebp2x = _ref.tabletLandscapeWebp2x,
      desktopImg = _ref.desktopImg,
      desktopImg2x = _ref.desktopImg2x,
      desktopWebp = _ref.desktopWebp,
      desktopWebp2x = _ref.desktopWebp2x,
      Head = _ref.Head;
  var media = {
    mobile: "(max-width: " + _constellation.ThemeConstellation.constellation.breakpoints.sm + "px)",
    mobile2x: "(max-width: " + _constellation.ThemeConstellation.constellation.breakpoints.sm + "px) and ((-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi))",
    tabletPortrait: "(max-width: " + _constellation.ThemeConstellation.constellation.breakpoints.lg + "px) and (min-width: " + _constellation.ThemeConstellation.constellation.breakpoints.sm + "px)",
    tabletPortrait2x: "(max-width: " + _constellation.ThemeConstellation.constellation.breakpoints.lg + "px) and (min-width: " + _constellation.ThemeConstellation.constellation.breakpoints.sm + "px) and ((-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi))",
    tabletLandscape: "(max-width: " + _constellation.ThemeConstellation.constellation.breakpoints.xxl + "px) and (min-width: " + _constellation.ThemeConstellation.constellation.breakpoints.lg + "px)",
    tabletLandscape2x: "(max-width: " + _constellation.ThemeConstellation.constellation.breakpoints.xxl + "px) and (min-width: " + _constellation.ThemeConstellation.constellation.breakpoints.lg + "px) and ((-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi))",
    desktop: "(min-width: " + _constellation.ThemeConstellation.constellation.breakpoints.xxl + "px)",
    desktop2x: "(min-width: " + _constellation.ThemeConstellation.constellation.breakpoints.xxl + "px) and ((-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi))"
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Head, null, /*#__PURE__*/_react.default.createElement("link", {
    rel: "preload",
    as: "image",
    href: mobileWebp,
    media: media.mobile,
    fetchPriority: "high"
  }), /*#__PURE__*/_react.default.createElement("link", {
    rel: "preload",
    as: "image",
    href: mobileWebp2x,
    media: media.mobile2x,
    fetchPriority: "high"
  }), /*#__PURE__*/_react.default.createElement("link", {
    rel: "preload",
    as: "image",
    href: tabletPortraitWebp,
    media: media.tabletPortrait,
    fetchPriority: "high"
  }), /*#__PURE__*/_react.default.createElement("link", {
    rel: "preload",
    as: "image",
    href: tabletPortraitWebp2x,
    media: media.tabletPortrait2x,
    fetchPriority: "high"
  }), /*#__PURE__*/_react.default.createElement("link", {
    rel: "preload",
    as: "image",
    href: tabletLandscapeWebp,
    media: media.tabletLandscape,
    fetchPriority: "high"
  }), /*#__PURE__*/_react.default.createElement("link", {
    rel: "preload",
    as: "image",
    href: tabletLandscapeWebp2x,
    media: media.tabletLandscape2x,
    fetchPriority: "high"
  }), /*#__PURE__*/_react.default.createElement("link", {
    rel: "preload",
    as: "image",
    href: desktopWebp,
    media: media.desktop,
    fetchPriority: "high"
  }), /*#__PURE__*/_react.default.createElement("link", {
    rel: "preload",
    as: "image",
    href: desktopWebp2x,
    media: media.desktop2x,
    fetchPriority: "high"
  })), /*#__PURE__*/_react.default.createElement("picture", null, /*#__PURE__*/_react.default.createElement("source", {
    media: media.mobile2x,
    srcSet: mobileWebp2x,
    type: "image/webp"
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: media.mobile,
    srcSet: mobileWebp,
    type: "image/webp"
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: media.mobile2x,
    srcSet: mobileImg2x
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: media.mobile,
    srcSet: mobileImg
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: media.tabletPortrait2x,
    srcSet: tabletPortraitImg2x
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: media.tabletPortrait,
    srcSet: tabletPortraitWebp,
    type: "image/webp"
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: media.tabletPortrait2x,
    srcSet: tabletPortraitWebp2x,
    type: "image/webp"
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: media.tabletPortrait,
    srcSet: tabletPortraitImg
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: media.tabletLandscape2x,
    srcSet: tabletLandscapeWebp2x,
    type: "image/webp"
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: media.tabletLandscape,
    srcSet: tabletLandscapeWebp,
    type: "image/webp"
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: media.tabletLandscape2x,
    srcSet: tabletLandscapeImg2x
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: media.tabletLandscape,
    srcSet: tabletLandscapeImg
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: media.desktop2x,
    srcSet: desktopWebp2x,
    type: "image/webp"
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: media.desktop,
    srcSet: desktopWebp,
    type: "image/webp"
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: media.desktop2x,
    srcSet: desktopImg2x
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: media.desktop,
    srcSet: desktopImg
  }), /*#__PURE__*/_react.default.createElement(_constellation.Box, {
    as: "img",
    alt: "",
    role: "presentation",
    src: desktopWebp,
    sx: {
      pointerEvents: 'none',
      position: 'absolute',
      inset: '0px',
      objectFit: 'cover',
      width: '100%',
      height: '100%',
      objectPosition: 'center ',
      zIndex: -1
    }
  })));
};

exports.HeroImage = HeroImage;
HeroImage.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Identifies mobile image media.
   */
  mobileImg: _propTypes.default.string.isRequired,

  /**
   * Identifies mobile image 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  mobileImg2x: _propTypes.default.string.isRequired,

  /**
   * Identifies mobile webp media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  mobileWebp: _propTypes.default.string.isRequired,

  /**
   * Identifies mobile webp 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  mobileWebp2x: _propTypes.default.string.isRequired,

  /**
   * Identifies tablet portrait image media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletPortraitImg: _propTypes.default.string.isRequired,

  /**
   * Identifies tablet portrait image 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletPortraitImg2x: _propTypes.default.string.isRequired,

  /**
   * Identifies tablet portrait webp media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletPortraitWebp: _propTypes.default.string.isRequired,

  /**
   * Identifies tablet portrait webp 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletPortraitWebp2x: _propTypes.default.string.isRequired,

  /**
   * Identifies tablet landscape image media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletLandscapeImg: _propTypes.default.string.isRequired,

  /**
   * Identifies tablet landscape image 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletLandscapeImg2x: _propTypes.default.string.isRequired,

  /**
   * Identifies tablet landscape webp media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletLandscapeWebp: _propTypes.default.string.isRequired,

  /**
   * Identifies tablet landscape webp 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletLandscapeWebp2x: _propTypes.default.string.isRequired,

  /**
   * Identifies desktop image media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  desktopImg: _propTypes.default.string.isRequired,

  /**
   * Identifies desktop image 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  desktopImg2x: _propTypes.default.string.isRequired,

  /**
   * Identifies desktop webp media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  desktopWebp: _propTypes.default.string.isRequired,

  /**
   * Identifies desktop webp 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  desktopWebp2x: _propTypes.default.string.isRequired,

  /**
   * Identifies the Head component from Next.js - if provided images are
   * preloaded.
   */
  Head: _propTypes.default.func
} : {};
HeroImage.defaultProps = {
  Head: function Head() {
    return null;
  }
};